<template>
  <el-select v-bind="$attrs" v-on="$listeners" ref="select" @hook:mounted="cancalReadOnly" @visible-change="cancalReadOnly" filterable v-model="curValue" >
    <slot></slot>
  </el-select>
</template>
<script>
export default {
  props: {
    value: {
      default: "",
    },
  },
  data() {
    return {
      curValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.curValue = newVal; // 确保外部值变化时内部值同步更新
    },
    curValue(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          if (select) {
            const input = select.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
        }
      });
    },
  },
};
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/filter-select/index.vue"
}
</vue-filename-injector>
